import React from "react";
import {
  createComponentBase,
  BaseComponentProps,
} from "../../../libs/components";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Icon } from "../icon";

export interface DateRangePickerProps extends BaseComponentProps {
  className?: string;
  value: any;
  setValue: (value: DateObject[]) => void;
  onlyMonthPicker?: boolean;
  onlyYearPicker?: boolean;
  weekPicker?: boolean;
  maxDate?: Date;
  minDate?: Date;
}

export const DateRangePicker = ({
  value,
  onlyMonthPicker = false,
  onlyYearPicker = false,
  weekPicker = false,
  maxDate,
  minDate,
  setValue,
  className,
}: DateRangePickerProps) => {
  const componentClassName = "a-dateRangePicker";
  const modifiers = {};
  const { Container } = createComponentBase(componentClassName, "div");

  const CustomInput = ({
    onFocus,
    value,
  }: {
    onFocus?: () => void;
    value?: string;
  }) => {
    return (
      <div>
        <div className={`${componentClassName}__input`} onFocus={onFocus}>
          <input
            className={`${componentClassName}__input__field`}
            value={value}
            readOnly
          />
          <div className={`${componentClassName}__input__icon`}>
            <Icon icon="calendar" />
          </div>
        </div>
      </div>
    );
  };

  const datePickerRef = React.useRef<any>(null);

  return (
    <Container className={className} modifiers={modifiers}>
      <DatePicker
        containerClassName={`${componentClassName}__input__container`}
        render={<CustomInput />}
        numberOfMonths={2}
        value={value}
        onChange={(dateObjects:DateObject[]) => {
          setValue(dateObjects as DateObject[]);
        }}
        onlyMonthPicker={onlyMonthPicker}
        onlyYearPicker={onlyYearPicker}
        weekPicker={weekPicker}
        range
        rangeHover
        displayWeekNumbers
        ref={datePickerRef}
        maxDate={maxDate}
        minDate={minDate}
        calendarPosition="bottom-right"
      >
        <div className={`${componentClassName}__footer`}>
          <button
            onClick={() => datePickerRef?.current.closeCalendar()}
            className={`${componentClassName}__footer__ok`}
          >
            Apply
          </button>
          <button
            onClick={() => {
              setValue([]);
              datePickerRef?.current.closeCalendar();
            }}
            className={`${componentClassName}__footer__cancel`}
          >
            Cancel
          </button>
        </div>
      </DatePicker>
    </Container>
  );
};
